import { subscriptionsByUid } from '../store/slices/subscription/subscriptionSlice';
import { SiteId } from 'wly-ecommerce-common';
import { SiteConfig } from './SiteConfig';

interface GetSubscriptionsResult {
  [key: string]: subscriptionsByUid;
}
export const filterSubscription = (
  subscriptions: GetSubscriptionsResult
): GetSubscriptionsResult => {
  const siteId = SiteConfig.getConfig().siteId;
  return Object.keys(subscriptions).reduce((acc, key) => {
    const subscription = subscriptions[key];
    if (
      siteId === SiteId.WILEYCOM ||
      subscription.subscriptionSiteId === siteId
    ) {
      acc[key] = subscription;
    }
    return acc;
  }, {});
};
